type Reset = () => void

const resets = new Set<Reset>()

/**
 * Every singleton that holds state — the query client, a store, the stream
 * connection, the token — registers how to clear itself. Logout calls
 * `runResets()` once and nothing is left behind for the next user.
 *
 * Returns an unregister function so tests can clean up.
 */
export function registerReset(reset: Reset): () => void {
  resets.add(reset)
  return () => {
    resets.delete(reset)
  }
}

export function runResets(): void {
  for (const reset of resets) {
    try {
      reset()
    } catch (error) {
      // One failing reset must not leave the others un-run — logout has to
      // clear everything it can, then let the redirect happen.
      console.error('reset failed', error)
    }
  }
}
